module.exports = __webpack_public_path__ + "img/linkd2-2.b6e1df9a.jpg";